module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('h1', [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', [_vm._v("I’d like to thank Hugh and Carol Landon, who have always given me amazing parental support. My brothers, sister and whole family who have always been there for me.")]), _vm._v(" "), _c('p', [_vm._v("Jody Katy Barry, who has always offered amazing friendship and gave me emotional and practical support through my school years.")]), _vm._v(" "), _c('p', [_vm._v("All the staff at the Howard of Effingham School who made everything accessible for me.")]), _vm._v(" "), _c('p', [_vm._v("Ros Reeve and Angela Baker, who were learning support assistants all through primary school.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f3df42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch004.vue
// module id = 72
// module chunks = 0